import React, { FunctionComponent } from 'react';
import { SanityLinkButton } from '../../../types/common';
import InternalLink from '../../InternalLink';
import { ExternalLinkIcon, InternalLinkIcon } from '../../Icons';

type LinkButtonProps = {
  data: SanityLinkButton;
}

const LinkButton: FunctionComponent<LinkButtonProps> = ({ data }) => {
  if (data.typeLink === 'internal' && data.internalLink) {
    return (
      <InternalLink
        reference={data.internalLink}
        className='primary-button'
      >
        {data.title}
        <InternalLinkIcon />
      </InternalLink>
    );
  }

  return (
    <a
      href={data.externalLink ? data.externalLink : '#'}
      target='_blank'
      rel='noreferrer noopener'
      className='primary-button'
    >
      {data.title}
      <ExternalLinkIcon />
    </a>
  );
}

export default LinkButton;
